import type { CityConfig } from "../city-template/types";

export const sterlingHeightsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — marriage license issuance" },
    { label: "Divorce Records — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Sterling Heights",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "sterling-heights",
  route: "/sterling-heights",
  title: "Emergency Passport Sterling Heights, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Sterling Heights, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Sterling Heights, Warren, Clinton Township, Shelby Township, and all Macomb County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Sterling Heights, MI",
  heroSubtitle: "Sterling Heights travelers — from Macomb County families to auto supplier professionals to northern Detroit suburb residents — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Macomb County and the northern Detroit metro.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Sterling%20Heights%20Michigan%20suburban%20landscape%20with%20tree-lined%20residential%20streets%2C%20modern%20shopping%20centers%2C%20wide%20boulevards%20and%20well-maintained%20parks%2C%20green%20lawns%20and%20mature%20trees%2C%20warm%20afternoon%20sunlight%2C%20peaceful%20suburban%20atmosphere%20in%20northern%20Detroit%20metro%20area%2C%20professional%20photography%20without%20text%20or%20people&width=1800&height=700&seq=sterling-heights-hero-002&orientation=landscape",
  heroImageAlt: "Sterling Heights Michigan suburban landscape with tree-lined streets and parks in northern Detroit metro",
  geoPosition: "42.5803;-83.0302",
  geoPlacename: "Sterling Heights, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 30–40 minutes south of Sterling Heights via I-75",
  },
  nearbyCitiesZips: [
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Clinton Township", zips: "48035, 48036, 48038" },
    { name: "Shelby Township", zips: "48315, 48316, 48317" },
    { name: "Utica", zips: "48315, 48317, 48318" },
    { name: "Fraser", zips: "48026" },
    { name: "Roseville", zips: "48066" },
    { name: "Mount Clemens", zips: "48043, 48046" },
    { name: "Saint Clair Shores", zips: "48080, 48081, 48082" },
    { name: "Eastpointe", zips: "48021" },
    { name: "Center Line", zips: "48015" },
    { name: "New Baltimore", zips: "48047" },
    { name: "Chesterfield", zips: "48047, 48051" },
    { name: "Harrison Township", zips: "48045" },
    { name: "Richmond", zips: "48062, 48063" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Detroit Passport Agency — no 30-minute drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-car-line", title: "Auto Supplier Corridor", desc: "Serving Macomb County manufacturing and supplier professionals" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Macomb County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Warren, MI", route: "/michigan" },
    { name: "Emergency passport help in Troy, MI", route: "/troy-mi" },
    { name: "Urgent passport services in Detroit, MI", route: "/detroit" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Sterling Heights, Michigan remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (30–40 minutes south via I-75) — without you making the drive or dealing with downtown Detroit parking. Sterling Heights residents can ship from any UPS or FedEx in Macomb County.",
  fpcOfficeDistance: "Serving Sterling Heights, Warren, Clinton Township, Shelby Township, Utica, Fraser, Roseville, Mount Clemens, and all of Macomb County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Sterling Heights and Macomb County. From the Lakeside Mall area to the M-59 corridor, from the Van Dyke corridor to the northern communities of Shelby and New Baltimore — we serve all of the northern Detroit suburbs.",
  nearbyCitiesIntro: "We serve Sterling Heights and all Macomb County communities including Warren, Clinton Township, Shelby Township, Utica, Fraser, Roseville, Mount Clemens, Saint Clair Shores, Eastpointe, Center Line, New Baltimore, Chesterfield, Harrison Township, and Richmond. We also serve eastern Oakland County communities.",
  howItWorksIntro: "Most Sterling Heights travelers complete everything online and ship documents overnight. No need to drive 30–40 minutes to downtown Detroit or find parking at the federal building — our couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Sterling Heights is one of the largest suburbs in Metro Detroit with a significant international population and strong auto industry ties. Here are the most common passport mistakes we see from Macomb County travelers.",
  testimonialsIntro: "Sterling Heights travelers — from Macomb County families to auto supplier professionals to international visitors — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Sterling Heights, MI? Here are the most common ones we hear from Macomb County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for Macomb County business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — 30 min drive + parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Sterling Heights travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Macomb County business and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Sterling Heights adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Macomb County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Sterling Heights residents and families — including new citizens, students, and Macomb County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Sterling Heights residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Sterling Heights and Macomb County families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Sterling Heights and Macomb County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Sterling Heights MI", description: "Urgent passport processing for Sterling Heights Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Sterling Heights MI", description: "Fast passport renewal for Sterling Heights Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Sterling Heights MI", description: "New passport application services for Sterling Heights Michigan residents applying for their first passport." },
    { name: "Child Passport Sterling Heights MI", description: "Minor passport services for Sterling Heights Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Diana S.",
      location: "Sterling Heights, MI",
      rating: 5,
      text: "Family trip to Greece in 6 days and my daughter's passport was expired. Fast Passport Center handled everything — delivered her renewed passport in 3 days. We shipped from the UPS Store on Hall Road and it was effortless.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Mark B.",
      location: "Warren, MI",
      rating: 5,
      text: "Business trip to Mexico with 4 days notice. Fast Passport Center had my passport ready in 36 hours. Their courier walked into the Detroit agency while I was at work in Sterling Heights. Incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Nina P.",
      location: "Clinton Township, MI",
      rating: 5,
      text: "Three passports for our family vacation to Jamaica — one renewal, two first-time for our teenagers. Done in 7 days. The online process was simple and the agent kept us updated daily. Highly recommend.",
      service: "Family Passport Bundle",
    },
    {
      name: "Tom H.",
      location: "Shelby Township, MI",
      rating: 5,
      text: "Auto supplier conference in Germany and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. The process was completely hands-off from my end.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "sh-1",
      name: "Sterling Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40111 Dodge Park Rd",
      city: "Sterling Heights",
      state: "MI",
      zip: "48313",
      phone: "(586) 247-4000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Sterling Heights, near Lakeside Mall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Sterling Heights acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Lakeside Mall area and the M-59 corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "sh-2",
      name: "Warren Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "28400 Mound Rd",
      city: "Warren",
      state: "MI",
      zip: "48092",
      phone: "(586) 573-4080",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Warren, approximately 6 miles south of Sterling Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Warren, Center Line, and southern Macomb County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "sh-3",
      name: "Clinton Township Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "42400 Garfield Rd",
      city: "Clinton Township",
      state: "MI",
      zip: "48038",
      phone: "(586) 286-0600",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Clinton Township, approximately 6 miles east of Sterling Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Clinton Township, Mount Clemens, and eastern Macomb County communities.",
      icon: "ri-mail-line",
    },
    {
      id: "sh-4",
      name: "Shelby Township Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "51260 Van Dyke Ave",
      city: "Shelby Township",
      state: "MI",
      zip: "48316",
      phone: "(586) 726-2710",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Shelby Township, approximately 5 miles north of Sterling Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Shelby Township, Utica, and northern Macomb County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "sh-5",
      name: "Roseville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18151 13 Mile Rd",
      city: "Roseville",
      state: "MI",
      zip: "48066",
      phone: "(586) 777-8110",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Roseville, approximately 10 miles south of Sterling Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Roseville, Eastpointe, and southern Macomb County communities.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Macomb County" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Parking & Downtown Hassle", agency: "Yes — downtown Detroit parking fees", fpc: "No — never leave Sterling Heights" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Sterling Heights auto supplier professionals and families often discover passport issues right before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops near Hall Road or Van Dyke sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Macomb County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Sterling Heights and Warren Post Office appointments fill during summer and spring break travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
    {
      icon: "ri-time-line",
      title: "Not Checking Passport Validity Before Booking",
      description: "Many countries require 6 months of passport validity beyond your travel dates. Check your passport expiration before booking international flights from DTW or FNT.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Macomb County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Hall Road, Van Dyke, or M-59." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Sterling Heights address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Sterling Heights, MI?", a: "Fast Passport Center offers emergency passport processing in Sterling Heights, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (30–40 minutes south via I-75) — without you taking time off work or finding parking in downtown Detroit." },
    { q: "Where is the nearest passport agency to Sterling Heights?", a: "The Detroit Passport Agency is the nearest facility to Sterling Heights, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 30–40 minutes south via I-75. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can skip the appointment backlog." },
    { q: "Can I get an expedited passport in Warren, Clinton Township, or Shelby Township?", a: "Absolutely. Fast Passport Center serves all of Macomb County including Warren, Clinton Township, Shelby Township, Utica, Fraser, Roseville, Mount Clemens, Saint Clair Shores, Eastpointe, Center Line, New Baltimore, Chesterfield, and Harrison Township. Our courier service works the same way everywhere." },
    { q: "What airports do Sterling Heights travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Sterling Heights residents — approximately 45 minutes south via I-75. DTW offers direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Bishop International (FNT) in Flint is a secondary option for some domestic and limited international routes. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Sterling Heights, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Sterling Heights residents get passport photos taken locally?", a: "Yes. Walgreens, CVS, and Meijer locations throughout Sterling Heights, Warren, and Clinton Township offer passport photos. UPS Stores and FedEx Office locations also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve Saint Clair Shores and Harrison Township?", a: "Yes. Fast Passport Center serves all of Macomb County including the lakeshore communities of Saint Clair Shores and Harrison Township. Our courier service is especially valuable for residents along the Lake Saint Clair shoreline who would otherwise face the commute to downtown Detroit." },
    { q: "Can I upgrade my processing speed after I submit?", a: "If you submit through a post office or directly to the government, no — you cannot upgrade speed after submission. With Fast Passport Center, you can upgrade your processing speed at any point before your documents are submitted to the agency. That's a major advantage of our service." },
  ],
  photoLocations: [
    { name: "Meijer — Hall Road Sterling Heights", address: "33201 Van Dyke Ave, Sterling Heights, MI 48312", hours: "Mon–Sun: 6AM–Midnight" },
    { name: "Walgreens — 15 Mile Road Sterling Heights", address: "37001 15 Mile Rd, Sterling Heights, MI 48310", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Lakeside Mall Area", address: "13745 Lakeside Cir, Sterling Heights, MI 48313", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Van Dyke Warren", address: "29111 Van Dyke Ave, Warren, MI 48093", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Sterling Heights", address: "33101 Van Dyke Ave, Sterling Heights, MI 48312", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State for driver's licenses, REAL ID, and vehicle registration. Online reservations strongly recommended.", featured: true },
    { name: "Michigan SOS — Warren", address: "13500 E 12 Mile Rd, Warren, MI 48088", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Warren, Center Line, and southern Macomb County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "45–50 minutes from Sterling Heights via I-75",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Sterling Heights and Macomb County. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "FNT",
      name: "Bishop International Airport (Flint)",
      distance: "Approximately 50 minutes north of Sterling Heights via I-75",
      address: "3425 W Bristol Rd, Flint, MI 48507",
      note: "Secondary option for Sterling Heights travelers. Direct flights to Orlando, Tampa, Las Vegas, and Chicago. Some residents find FNT more convenient for domestic travel.",
      flightUrl: "https://www.bishopairport.org/",
      flightLabel: "FNT Flight Info",
      featured: false,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "Approximately 45 minutes southeast via I-94 and Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Alternative option for travelers crossing to Canada. Smaller airport with limited international routes. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};